import events from './store/events';
import store from '@/core/store';

export const connect = (opts = {}) => {
  store.registerModule('events$events', events);
};
